import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Header from './header';
import Navigation from './navigation';
import Footer from './footer';
import Iframe from './iframe';
class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { nav, search, topAd, logo, channelAd, navigation, bottomAd, footer, cooperation } = this.props.content;

        // 头部
        const headerData = {
            nav,
            search,
            topAd,
            logo,
            channelAd,
        };
        // 导航
        const navigationData = {
            nav: navigation,
        };
        // footer
        const footerData = {
            bottomAd,
            footer,
        };

        return (
            <div className={styles.layout}>
                {/* 页头 */}
                <Header content={headerData} IE78={false} />
                {/* 导航 */}
                <Navigation content={navigationData} />
                <Iframe />
                <Footer content={footerData} />
            </div>
        );
    }
}

export default Layout;
